import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

//Ext Job Schedules
const postWorkflowsPending = (state: AppState) => state.workFlowPostReducer.pending;
const postWorkflows = (state: AppState) => state.workFlowPostReducer.workflow;
const postWorkflowsError = (state: AppState) => state.workFlowPostReducer.error;

export const postWorkflowsPendingSelector = createSelector(postWorkflowsPending, (pending) => pending);
export const postWorkflowsSelector = createSelector(postWorkflows, (workflow) => workflow);
export const postWorkflowsErrorSelector = createSelector(postWorkflowsError, (error) => error);